import { truncateSelectedValues } from "./utils";
export const getFormattedPriceRangeAndTags = (priceRange = "", tags = "")=>{
    if (priceRange && tags) return truncateSelectedValues([
        priceRange,
        tags
    ], 4, "and");
    return priceRange || tags;
};
